import { Link } from "react-router-dom";
import { Clapperboard } from "lucide-react";
import { useLang } from "../store";

export default function Footer() {
  const { t } = useLang();
  const links = [
    ["/", "studio"], ["/filmografia", "filmografia"], ["/noleggio-attrezzatura", "attrezzatura"],
    ["/noleggio-costumi", "costumi"], ["/stunt", "stunt"], ["/galleria", "galleria"],
    ["/produzioni", "produzioni"], ["/chi-sono", "chisono"], ["/proiezione", "proiezione"],
    ["/contatti", "contatti"],
  ];
  return (
    <footer className="border-t border-white/10 bg-[#050608]" data-testid="footer">
      <div className="mx-auto grid max-w-[1600px] gap-10 px-6 py-14 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-3">
            <span className="flex h-9 w-9 items-center justify-center rounded bg-amber-600 text-black">
              <Clapperboard size={20} />
            </span>
            <span className="font-display text-lg tracking-wide">{t("brand")}</span>
          </div>
          <p className="font-serif-it mt-4 text-lg italic text-slate-400">{t("footer.tagline")}</p>
        </div>
        <div>
          <p className="font-mono2 mb-4 text-[11px] tracking-[0.3em] text-amber-500">{t("footer.nav")}</p>
          <div className="grid grid-cols-2 gap-2">
            {links.map(([to, key]) => (
              <Link key={key} to={to} className="text-sm text-slate-400 transition-colors hover:text-amber-500">{t(`nav.${key}`)}</Link>
            ))}
          </div>
        </div>
        <div>
          <p className="font-mono2 mb-4 text-[11px] tracking-[0.3em] text-amber-500">{t("footer.contact")}</p>
          <Link to="/contatti" className="text-sm text-slate-400 transition-colors hover:text-amber-500" data-testid="footer-email">
            {t("footer.contactCta")}
          </Link>
        </div>
      </div>
      <div className="border-t border-white/5 py-5 text-center">
        <p className="font-mono2 text-[11px] tracking-widest text-slate-600">© {new Date().getFullYear()} DAVIDE CAMPAGNA · {t("footer.rights")}</p>
      </div>
    </footer>
  );
}
